module.exports = __webpack_public_path__ + "img/share-fail@3x.a96aea6f.png";